import { PROGRAM_TYPES } from 'site-modules/shared/components/incentives/incentives-wizard/constants/program-types';
import { FEDERAL_SUBTYPE_ID } from 'site-modules/shared/components/incentives/incentives-wizard/constants/subtype-ids';

export function isLocalEvRebate(incentive) {
  const { programType, subtypeId } = incentive;
  return programType === PROGRAM_TYPES.EV_REBATE && subtypeId !== FEDERAL_SUBTYPE_ID;
}
